import { Checkbox, createTheme, FormControlLabel } from "@mui/material";

//import images and icons
import { Stop, TickSquare } from "iconsax-react";
import { IS_MOBILE } from "../../../constants/breakpoints";

function BaseCheckbox({ label, name, checked, handleChange, disabled, otherName }) {
    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536,
            },
        },
    });
    return (
        <FormControlLabel
            control={
                <Checkbox
                    onChange={event => handleChange(event, otherName)}
                    name={name}
                    icon={<Stop size={IS_MOBILE ? "22" : "24"} color={disabled ? "var(--medium-gray-color)" : "var(--teal-color-18)"} />}
                    checkedIcon={<TickSquare size={IS_MOBILE ? "22" : "24"} color="var(--secondary-color)" variant="Bold" />}
                />
            }
            checked={checked || false}
            label={label}
            disabled={disabled}
            sx={{
                margin: 0,
                padding: "4px 8px",
                "& span": {
                    fontSize: "0.875rem",
                    padding: "2px",
                    [theme.breakpoints.between("xs", "md")]: {
                        fontSize: "0.625rem",
                    },
                },
            }}
        />
    );
}

export default BaseCheckbox;
